import Vue from 'vue'
import constants from '@/libs/utils/constants'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    FETCH_TIMESHEET: (state, { userId, weekStart }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/api/timesheets/${userId}/week`, { params: { weekStart } })
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    CREATE_TIMESHEET_SLOT: (state, payload) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post('/api/timesheets/slots', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    UPDATE_TIMESHEET_SLOT: (state, {
      slotId, startTime, endTime, hours,
    }) =>
      new Promise((resolve, reject) => {
        const payload = { TimesheetSlotId: slotId }
        if (startTime !== undefined) payload.StartTime = startTime
        if (endTime !== undefined) payload.EndTime = endTime
        if (hours !== undefined) payload.Hours = hours
        Vue.prototype.$http
          .put(`/api/timesheets/slots/${slotId}`, payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    EXPORT_TIMESHEETS: (state, { timesheetStart }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get('/api/timesheets/export', { params: { timesheetStart } })
          .then(res => resolve(res.data))
          .catch(err => reject(err))
      }),
    CREATE_ABSENCE_SLOT: (state, { timesheetId, workDate, comment }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post('/api/timesheets/slots', {
            TimesheetId: timesheetId,
            WorkDate: workDate,
            SlotType: constants.timesheetSlotType.Absence,
            Comment: comment,
          })
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
  },
}
